//**
// * Injects chatbot and resource scripts into the document head.
//
export const injectChatbotScripts = () => {
  // Get environment variables from window object (for client-side JS)
  const chatbotSrc = process.env.REACT_APP_CHATBOT_URL;
  const resourceSrc = process.env.REACT_APP_CHATBOT_RESOURCE_URL;

  const appendBootstrap = async () => {
    if (resourceSrc) {
      const resourceScript = document.createElement('script');
      resourceScript.type = 'text/javascript';
      resourceScript.defer = true;
      resourceScript.src = resourceSrc;
      resourceScript.async = true;
      resourceScript.onload = async () => {
        if (window.initEmbeddedMessaging) {
          window.initEmbeddedMessaging();
        }
      };
      document.head.appendChild(resourceScript);
    }
  };

  if (chatbotSrc) {
    const chatbotScript = document.createElement('script');
    chatbotScript.type = 'text/javascript';
    chatbotScript.defer = true;
    chatbotScript.src = chatbotSrc;
    chatbotScript.async = true;
    chatbotScript.onload = () => appendBootstrap();
    document.head.appendChild(chatbotScript);
  }
};
